const EXPORT_TRANSLATION_MAX_ATTEMPTS = 3;

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function readTranslationErrorMessage(response) {
  try {
    const rawBody = await response.text();

    if (!rawBody) {
      return "Translation failed.";
    }

    try {
      const body = JSON.parse(rawBody);
      if (body?.error) {
        return body.error;
      }
    } catch (error) {
      // Ignore parse errors and fall through to the raw body.
    }

    return rawBody;
  } catch (error) {
    return "Translation failed.";
  }
}

export async function exportTranslateBlock(text, targetLanguage, options = {}) {
  const { sourceLanguage, maxAttempts = EXPORT_TRANSLATION_MAX_ATTEMPTS } = options;
  let lastError = null;

  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    try {
      const response = await fetch("/api/echo/export-translate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text, targetLanguage, sourceLanguage })
      });

      if (!response.ok) {
        throw new Error(await readTranslationErrorMessage(response));
      }

      const { translatedText } = await response.json();

      if (!translatedText) {
        throw new Error("Translation returned empty result.");
      }

      return translatedText;
    } catch (error) {
      lastError = error;
      if (attempt < maxAttempts) {
        await sleep(700 * attempt);
      }
    }
  }

  throw lastError || new Error("Translation failed.");
}

export function getLanguageLabel(language) {
  const labels = {
    "zh-CN": "简体中文",
    "zh-TW": "繁體中文",
    "en-US": "English",
    "en-GB": "English",
    "fr-FR": "Français",
    "fr-CA": "Français",
    "ja-JP": "日本語"
  };

  return labels[language] || language;
}
